module.exports = __webpack_public_path__ + "img/general-trading.a4e8d836.jpg";